<div
  class="tooltip-content"
  [style.max-width]="maxWidth()"
  [@fadeInOnEnter]="animationName()"
  [@fadeOutOnLeave]="leaveAnimationName()">
  @if (!isTemplate()) {
    @if (displayContent() !== null) {
      <div [innerHTML]="displayContent()"></div>
    }
    @if (displayContent() === null) {
      <ng-content></ng-content>
    }
  }
  @if (isTemplate()) {
    <ng-container [ngTemplateOutlet]="displayTemplate()"></ng-container>
  }
</div>
